import PropTypes from 'prop-types';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { auth } from './../utils/authToken';
import { LayoutNoFooter } from './../views/layouts';
import { MessagePage, SignupPage } from './../views/pages';

const routes = [
  {
    exact: true,
    path: '/',
    page: SignupPage,
    layout: LayoutNoFooter,
  },

  {
    exact: true,
    path: '/signup',
    page: SignupPage,
    layout: LayoutNoFooter,
  },
  // {
  //   exact: true,
  //   path: '/terms',
  //   page: TermsAndConditionsPage,
  //   layout: LayoutNoNavigation,
  // },
  // {
  //   exact: true,
  //   path: '/privacy',
  //   page: PrivacyPage,
  //   layout: LayoutNoNavigation,
  // },
  // {
  //   exact: true,
  //   path: '/blog',
  //   page: BlogPage,
  //   layout: LayoutNavigation,
  // },
  // {
  //   exact: true,
  //   path: '/blog/:name',
  //   page: BlogArticlePage,
  //   layout: LayoutNavigation,
  // },
  // {
  //   exact: true,
  //   path: '/pricing',
  //   page: PricingPage,
  //   layout: LayoutNavigation,
  // },
  // {
  //   exact: true,
  //   path: '/use-cases',
  //   page: PricingPage,
  //   layout: LayoutNavigation,
  // },
  // {
  //   exact: true,
  //   path: '/about',
  //   page: PricingPage,
  //   layout: LayoutNavigation,
  // },
  // {
  //   exact: true,
  //   path: '/theme',
  //   page: TestThemePage,
  //   layout: TestThemeLayout,
  // },
  {
    path: '',
    // eslint-disable-next-line react/display-name
    page: () => <MessagePage message={'Not found'} />,
    layout: LayoutNoFooter,
  },
];

const RouteWithSubRoutes = route => {
  return (
    <Route
      path={`${route.path}`}
      render={props =>
        !route.isPrivate ||
        (route.isPrivate && auth.isAuthenticated('jwtToken', 'jwtUser')) ? (
          <route.layout>
            <route.page {...props} routes={route.routes} />
          </route.layout>
        ) : (
          <Redirect
            to={{
              pathname: `/login`,
              // eslint-disable-next-line react/prop-types
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

RouteWithSubRoutes.propTypes = {
  route: PropTypes.arrayOf(PropTypes.object),
};

export { routes, RouteWithSubRoutes };



// WEBPACK FOOTER //
// ./src/routes/routes.js